import apiClient from './client';

export interface ServerAction {
  id: string;
  hostname: string;
  action_type: string;
  action_payload: string | null;
  status: 'pending' | 'claimed' | 'running' | 'completed' | 'failed';
  result: string | null;
  created_by_email: string | null;
  created_at: string;
  claimed_at: string | null;
  completed_at: string | null;
  subscription_id: string | null;
}

export interface AvailableUpgrade {
  version: string;
  release_date: string;
}

export interface AvailableUpgradesResponse {
  current_version: string;
  available_upgrades: AvailableUpgrade[];
}

export async function createAction(data: {
  subscription_id: string;
  action_type: string;
  payload?: Record<string, unknown>;
}): Promise<ServerAction> {
  const response = await apiClient.post('/api/v1/actions', data);
  return response.data.data;
}

export async function getActionById(id: string): Promise<ServerAction> {
  const response = await apiClient.get(`/api/v1/actions/${id}`);
  return response.data.data;
}

export async function listActionsBySubscription(subscriptionId: string): Promise<ServerAction[]> {
  const response = await apiClient.get(`/api/v1/actions?subscription_id=${subscriptionId}`);
  return response.data.data?.actions || [];
}

export async function getAvailableUpgrades(subscriptionId: string): Promise<AvailableUpgradesResponse> {
  const response = await apiClient.get(`/api/v1/actions/subscriptions/${subscriptionId}/available-upgrades`);
  return response.data.data;
}

export interface DeviceSearchResult {
  mac: string;
  model: string;
  name: string;
  site_name: string;
}

export interface DeviceSearchResponse {
  devices: DeviceSearchResult[];
}

export interface DeviceDeleteResponse {
  deleted_count: number;
  reboot_action_id?: string;
}
